import React from "react";
import "./NoResultsFound.css";
import noResultImg from "./img/no-result.jpg";
import { useNavigate } from "react-router-dom";

const NoResultsFound = ({ title, subtitle, message, onRetry, onBack }) => {
  const navigate = useNavigate();
  return (
    <div className="no-results-wrapper">
      <div className="no-results-content">
        <img className="no-results-img m-hide" src={noResultImg} alt="No results" />

        <div className="no-results-text">
          <h2 className="no-results-title">{title || "Search Helper"}</h2>
          <p className="no-results-subtitle">
            {subtitle || "Explore new possibilities"}
          </p>
          <p className="no-results-message">
            {message ||
              "We couldn’t find any results for your search. Try using different keywords or adjusting filters."}
          </p>

          <div className="no-results-actions">
            <button className="btn-primary" onClick={() => window.location.reload()}>
              <span className="icon-refresh">
                
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
                    <path d="M8.92259 6.75584C8.59715 7.08128 8.06951 7.08128 7.74408 6.75584C7.41864 6.4304 7.41864 5.90277 7.74408 5.57733L8.82149 4.49992H7.5C4.27834 4.49992 1.66667 7.11159 1.66667 10.3333C1.66667 13.5549 4.27834 16.1666 7.5 16.1666C10.7217 16.1666 13.3333 13.5549 13.3333 10.3333C13.3333 9.87301 13.7064 9.49992 14.1667 9.49992C14.6269 9.49992 15 9.87301 15 10.3333C15 14.4754 11.6421 17.8333 7.5 17.8333C3.35786 17.8333 0 14.4754 0 10.3333C0 6.19112 3.35786 2.83325 7.5 2.83325H8.82149L7.74408 1.75584C7.41864 1.4304 7.41864 0.902766 7.74408 0.57733C8.06951 0.251893 8.59715 0.251893 8.92259 0.57733L11.4226 3.07733C11.748 3.40277 11.748 3.9304 11.4226 4.25584L8.92259 6.75584Z" fill="white"/>
                  </svg>
                </span> Try Again
            </button>

            <button className="btn-secondary" onClick={() => navigate(-1)}>
              <span className="icon-back">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11" fill="none">
                  <path d="M15 4.66667H3.19167L6.175 1.675L5 0.5L0 5.5L5 10.5L6.175 9.325L3.19167 6.33333H15V4.66667Z" fill="#7464E4"/>
                </svg>
                </span> Go Back
            </button>

          </div>
        </div>
      </div>
    </div>
  );
};

export default NoResultsFound;
